const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const { SPLIT_CHAR_SPECIAL } = require('../../constants/Split');
const { default: SystemConstants } = require('../../common/SystemConstants');
const FiltroConstants = require('../../constants/FiltroConstants').default;
const Atributos = require('../../common/Atributos');
module.exports = {
    cubo: 'cubo_fichas',
    title: SystemConstants.Strings.paginas.dadosExposicaoVitimaHumanaEncerramento,
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC,
        Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
        Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    nextPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_DE_AGENTES,
    backPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_EXPOSICAO,
    charts: [
        {
            title: 'CLASSIFICAÇÃO DE GRAVIDADE FINAL',
            description: 'Classificação de Gravidade Final.',
            type: 'Pivottable',
            h: '100%',
            headers: ['Classificação de Gravidade Final', 'Quantidade'],
            selectDimensions: [Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO, Atributos.QNT],
            rows: ['Classificação de Gravidade Final'],
            rowOrder: 'value_z_to_a',
            // aggregatorName: 'Integer Sum',
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Quantidade',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            vals: ['Quantidade'],
            cols: [],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        if (value === 'Ignorada')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
        {
            title: 'CLASSIFICAÇÃO DE GRAVIDADE FINAL',
            type: 'ApexPieChart',
            w: 1,
            selectDimensions: [Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO, Atributos.QNT],
            groupByOp: 'sum',
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        if (value === 'Ignorada')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
            uiConfig: {
                enableAnimation: true,
                // totalDisplayState: 'total', // 'total' | 'parts'
                // orderDirection: 'asc', // 'asc' | 'desc'
                // orderType: 'count', // 'name' | 'count'
                // customLabelsArray: ['<1', '1-4', '5-9', '10-14', '15-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '>=80'],
            },
            // Traz um gráfico em colunas mostrando a situação dos exames de dermatologia por ano. Uma barra contém a contagem de exames "sem laudo" e a outra barra traz a contagem de exames "com laudo".
            // Este card pode ter seus dados filtrados pela variável "Data do exame" presente no dashboard.
        },
        {
            title: 'DESFECHO',
            description: 'Desfecho.',
            h: '100%',
            type: 'Pivottable',
            headers: ['Desfecho', 'Quantidade'],
            selectDimensions: [Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO, Atributos.QNT],
            rows: ['Desfecho'],
            rowOrder: 'value_z_to_a',
            // aggregatorName: 'Integer Sum',
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Quantidade',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            vals: ['Quantidade'],
            cols: [],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
        {
            title: 'DESFECHO',
            type: 'ApexPieChart',
            w: 1,
            selectDimensions: [Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO, Atributos.QNT],
            groupByOp: 'sum',
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
            uiConfig: {
                enableAnimation: true,
                // totalDisplayState: 'total', // 'total' | 'parts'
                // orderDirection: 'asc', // 'asc' | 'desc'
                // orderType: 'count', // 'name' | 'count'
                // customLabelsArray: ['<1', '1-4', '5-9', '10-14', '15-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '>=80'],
            },
            // Traz um gráfico em colunas mostrando a situação dos exames de dermatologia por ano. Uma barra contém a contagem de exames "sem laudo" e a outra barra traz a contagem de exames "com laudo".
            // Este card pode ter seus dados filtrados pela variável "Data do exame" presente no dashboard.
        },
        {
            title: 'GRUPO DE AGENTES POR DESFECHO',
            description: 'Grupo de Agentes por Desfecho.',
            type: 'Pivottable',
            w: 6,
            headers: ['Grupo de Agente', 'Desfecho', 'Quantidade'],
            selectDimensions: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC, Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO, Atributos.QNT],
            rows: ['Grupo de Agente'],
            rowOrder: 'value_z_to_a',
            // aggregatorName: 'Integer Sum',
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Total',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            enablePercentage: true,
            vals: ['Quantidade'],
            cols: ['Desfecho'],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
                {
                    attributes: [Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_SEXO,
            grupo: 'Paciente: Sexo',
            rotulo: 'Paciente: Sexo',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            grupo: 'Paciente: Faixa etária',
            rotulo: 'Paciente: Faixa etária',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            grupo: 'Exposição: Circunstância',
            rotulo: 'Exposição: Circunstância',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO,
            grupo: 'Classificação de Gravidade Final',
            rotulo: 'Classificação de Gravidade Final',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            grupo: 'Desfecho',
            rotulo: 'Desfecho',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 0,
            disabled: true,
            hidden: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de ficha',
            tipoComponente: 'IN_SELECT',
            valor: 'Humana',
        },
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 3,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_SEXO,
            rotulo: 'Sexo',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            rotulo: 'Faixa etária',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 6,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 7,
            size: 2,
            disabled: false,
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            rotulo: 'Circunstância',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 8,
            size: 2,
            disabled: false,
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            rotulo: 'Desfecho',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
